import React from 'react';

import { useDispatch } from 'react-redux';
import { setStatusSearch } from 'redux/search/searchSlice';
import { useTranslation } from 'react-i18next';
import { Search as SearchIcon, Sparkles } from 'lucide-react';

export const Search = ({ searchValue, setSearchValue }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onChange = event => {
    const inputValue = event.currentTarget.value;
    const isNumber = /^\d+$/.test(inputValue);

    setSearchValue(inputValue);

    if (isNumber) {
      dispatch(setStatusSearch(Number(inputValue)));
    } else {
      dispatch(setStatusSearch(inputValue));
    }
  };

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center">
      <div className="relative w-full">
        <SearchIcon
          size={18}
          className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
        />
        <input
          type="text"
          value={searchValue}
          onChange={onChange}
          placeholder={t('search.iconDescr')}
          className="h-12 w-full rounded-2xl border border-slate-200 bg-white pl-11 pr-4 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-[#FF7601] focus:ring-2 focus:ring-orange-100"
        />
      </div>
      {searchValue.trim().length > 5 && (
        <button
          type="button"
          className="inline-flex h-12 items-center justify-center gap-2 rounded-2xl bg-[#FF7601] px-4 text-sm font-semibold text-white shadow-sm transition hover:brightness-105"
        >
          <Sparkles size={16} />
          AI Create
        </button>
      )}
    </div>
  );
};
